import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  authToken: "",
};
const authTokenSlice = createSlice({
  name: "authToken",

  initialState,
  reducers: {
    setAuthToken: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.authToken = payload;
    },
    removeAuthToken: (state: any) => {
      state.authToken = "";
    },
  },
});

export const { setAuthToken, removeAuthToken } = authTokenSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default authTokenSlice.reducer;
